var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileChevronLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80078 5.9998L6.70078 9.89981C6.88411 10.0831 6.97578 10.3165 6.97578 10.5998C6.97578 10.8831 6.88411 11.1165 6.70078 11.2998C6.51745 11.4831 6.28411 11.5748 6.00078 11.5748C5.71745 11.5748 5.48411 11.4831 5.30078 11.2998L0.700781 6.6998C0.600781 6.5998 0.529948 6.49147 0.488281 6.3748C0.446615 6.25814 0.425781 6.13314 0.425781 5.9998C0.425781 5.86647 0.446615 5.74147 0.488281 5.6248C0.529948 5.50814 0.600781 5.3998 0.700781 5.2998L5.30078 0.699805C5.48411 0.516471 5.71745 0.424805 6.00078 0.424805C6.28411 0.424805 6.51745 0.516471 6.70078 0.699805C6.88411 0.883138 6.97578 1.11647 6.97578 1.3998C6.97578 1.68314 6.88411 1.91647 6.70078 2.0998L2.80078 5.9998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileChevronLeft);
export default __webpack_public_path__ + "static/media/mobile-chevron_left.309a306e8cb20aa0f1e33c629470d21c.svg";
export { ForwardRef as ReactComponent };